module.exports = __webpack_public_path__ + "img/mau2-12-nhan-202x162mm.ab1cd26d.jpg";